import _classCallCheck from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { PolygonDrawerBase } from "./PolygonDrawerBase";
export var PolygonDrawer = /*#__PURE__*/function (_PolygonDrawerBase) {
  _inherits(PolygonDrawer, _PolygonDrawerBase);

  var _super = _createSuper(PolygonDrawer);

  function PolygonDrawer() {
    _classCallCheck(this, PolygonDrawer);

    return _super.apply(this, arguments);
  }

  _createClass(PolygonDrawer, [{
    key: "getCenter",
    value: function getCenter(particle, radius) {
      var sides = this.getSidesCount(particle);
      return {
        x: -radius / (sides / 3.5),
        y: -radius / (2.66 / 3.5)
      };
    }
  }, {
    key: "getSidesData",
    value: function getSidesData(particle, radius) {
      var _a, _b;

      var polygon = particle.shapeData;
      var sides = (_b = (_a = polygon === null || polygon === void 0 ? void 0 : polygon.sides) !== null && _a !== void 0 ? _a : polygon === null || polygon === void 0 ? void 0 : polygon.nb_sides) !== null && _b !== void 0 ? _b : 5;
      return {
        count: {
          denominator: 1,
          numerator: sides
        },
        length: radius * 2.66 / (sides / 3)
      };
    }
  }]);

  return PolygonDrawer;
}(PolygonDrawerBase);